import { PackageType } from '~shared/types/pricing/package';

export enum LegaleseDisclaimer {
  TeamsDiscount = 'DISPLAYED_PRICING',
  OverageCost = 'PER_ADDITIONAL_RESPONSE',
  EnterpriseAddons = 'ADD_ON_FEATURES',
}

export default {
  [PackageType.Teams]: [
    LegaleseDisclaimer.TeamsDiscount,
    LegaleseDisclaimer.OverageCost,
    LegaleseDisclaimer.EnterpriseAddons,
  ],
  [PackageType.Individual]: [LegaleseDisclaimer.OverageCost],
  [PackageType.Educational]: [LegaleseDisclaimer.OverageCost],
};
